<template>
  <div
    class="mx-4 d-flex view-content"
  >
    <h2
      style="text-align:center"
      class="py-5"
    >
      サービス利用規約
    </h2>
    <pre
      class="pre-content"
    >
本規約は、ゼロスペック株式会社（以下「当社」といいます。）が「GoNOW」の名称で提供する、本サービス（第2条に定義します。）の利用に関する、当社とユーザ（第2条に定義します。）との間の契約関係を定めるものです。

<span class="sub-header">第1条（目的）</span>
1 当社は本規約に基づき本サービスを提供し、ユーザは本規約に従って本サービスを利用するものとします。
2 本規約は全ての本サービス利用契約に適用されますが、本サービス利用契約において明示的に本規約の内容を変更し、または適用を排除した場合には、本サービス利用契約の内容が本規約の内容に優先して適用されるものとします。

<span class="sub-header">第2条（定義）</span>
本規約における用語の定義は、本規約各条で定めるほか、以下のとおりとします。
1. 「本製品」とは、当社が製造し、貸与するワイヤレスの液体用在庫計測センサーをいいます。
(2) 「本サービス」とは、本製品に付随して当社がユーザに提供する、液体の在庫自動発注および配送管理サービスをいいます。
(3)「ユーザ」とは、本サービスを利用する事業者（法的形態を問いません。）をいいます。
(4)「知的財産権」とは、発明、考案、意匠、著作物、ノウハウ、営業秘密その他の知的財産について認められる特許権、実用新案権、意匠権、著作権その他の権利（これらを取得する権利を含みます。）または利益をいいます。
(5)「反社会的勢力」とは、暴力団、暴力団員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力集団等の反社会的勢力の総称をいいます。
(6)「ユーザID・パスワード」とは、ユーザが本サービスを利用するために必要な専用のIDおよびパスワードをいいます。
(7) 「本サービス用設備」とは、データセンター、基地局、通信回線、クラウドサービス等の本サービスを提供するための必要な設備、装置またはサービス（本製品を除きます。）をいいます。
(8) 「インフラ提供者」とは、本サービス用設備の提供者をいいます。
(9) 「当社システム管理者」とは、当社における管理者をいうものとし、ユーザID・パスワードをユーザに対して発行する権限を有するものとします。
(10) 「本サービス利用契約」とは、本サービスの提供に関し、本規約又はその他の合意に基づきユーザと当社との間で成立する契約をいうものとします。
(11) 「利用開始日」とは、ユーザがユーザID・パスワードを受領して本サービスの利用が可能になった日をいうものとします。
(12) 「ユーザ機器等」とは、ユーザが本サービスを利用するにあたって、購入、リース、賃借その他の事由に基づいて利用するネットワーク通信機器、PC、サーバ、その他のハードウェアおよびソフトウェア等であって、ユーザまたは第三者が保有するものを総称していいます。
(13) 「本データ」とは、本サービスの利用に伴い測定されるデータ、またはその他何らかの方法で当社とユーザの間で授受されるユーザ（ユーザが本製品を設置した容器を保有しているユーザの顧客を含みます。）に関するデータをいいます。

<span class="sub-header">第3条（本規約の変更）</span>
1 当社は、本規約を随時変更することがあります。本規約の変更およびユーザの同意により、本サービス利用契約についても変更後の本規約が適用されるものとします。
2 当社は、前項の変更を行う場合は、効力発生日を定めた上で、あらかじめ、変更後の本規約の内容を次条に定めるところにより、ユーザに通知し、または当社の管理するウェブサイトにて公表するものとします。効力発生日後もユーザが本サービスを利用した場合、変更後の本規約に同意したものとみなします。

<span class="sub-header">第4条（通知）</span>
1 当社からユーザへの通知は、電子メール、郵送または当社の管理するウェブサイトにおける掲示等、当社が適当と判断する方法により行います。
2 当社が前項の規定に基づいてユーザへの通知を、電子メールの送信、郵送または当社の管理するウェブサイトへの掲載の方法により行う場合には、前条第2項によるユーザの同意を必要とする場合を除き、それぞれ電子メールの送信、郵送またウェブサイトへの掲載を行った時点から当該通知はユーザに対して効力を生じるものとします。

<span class="sub-header">第5条（本サービス利用契約の成立・更新）</span>
1  本サービス利用契約は、本サービスの利用を希望する者（以下「利用希望者」といいます。）が、本規約の内容に同意の上で、第10条により当社が通知したユーザID・パスワードを使用して本サービスに初めてログインした時点で成立するものとします。なお、本サービスの利用を希望する者は、本規約に同意しない限り、本サービスを利用することはできません。
2 本サービス利用契約の期間は、当社とユーザとの間で別途の合意により定めるものとします。なお、当該契約期間の満了日60日前までに、当社はユーザに対し契約更新の意思を確認するための通知をするものとし、ユーザがそれに対し契約期間の満了日30日前までに契約更新する旨の回答をした場合、又は契約期間の満了日前30日前までに何らの回答をしなかった場合は、本サービス利用契約は同一内容にて1年間更新されるものとし、以後も同様とします。ただし、当社が更新を希望しない場合は、契約期間の満了日60日前までに、ユーザに対し更新しない旨の通知をするものとします。
3 本サービス利用契約締結後において、当社が、本サービスの利用に関して、ユーザとの間で、本サービス利用契約または本規約とは異なる条件で個別に書面による契約を結んだ場合には、別段の定めがない限り、当該個別の契約の条件が本サービス利用契約に優先するものとします。

<span class="sub-header">第6条（変更通知）</span>
1 ユーザは、その商号もしくは名称、本店所在地もしくは住所、または連絡先その他当社に通知した事項に変更があるときは、当社の定める方法により、変更予定日の60日前までに当社に通知するものとします。
2  当社は、ユーザが前項に従った通知を怠ったことにより、ユーザが通知の不到達その他の事由により損害を被った場合であっても、一切の責任を負わないものとします。

<span class="sub-header">第7条（本サービスの内容）</span>
1  ユーザが利用できる本サービスの内容は以下のとおりです。ただし、ユーザに付与されるアカウントの種類によって、以下の本サービスの内容が一部利用できない場合があります。
(1) ユーザの顧客（ユーザが本製品を設置した容器を保有しているユーザの顧客をいい、以下、単に「顧客」といいます。）が管理等する液体の在庫残量管理
(2) 顧客からの、液体の自動発注および発注管理
(3) 顧客が管理等する液体の在庫消費予測の表示
(4) 顧客への液体の配送のリストの自動作成および配送の指示
(5) 本サービスに関する問い合わせ対応および障害対応
2  以下の各号の事項については、本サービス利用契約において別段の明示がある場合を除き、本サービスに含まれないものとします。
(1) ユーザ機器等と本サービスまたは本製品間の通信サービス
(2) 本サービスまたは本製品に係るコンサルティングサービス
(3) 本サービスまたは本製品に係るシステム開発サービス
(4)本サービスまたは本製品に係る本データの内容、変更に関する問い合わせ対応サービス
(5)本サービスおよび本製品の導入および設定サービス（本製品の設置/交換、本サービスへのユーザの情報登録および設定）
3 ユーザは、本サービスが通信回線を通じてデータセンターを経由して非独占的に提供されるサービスであり、ユーザ機器等の性能、または通信環境もしくはデータセンターの利用状況等により、本サービスの可用性、通信速度、レスポンス等に影響が生じる可能性があることを予め了承するものとします。当社は、かかる影響について一切の責任を負わないものとします。
4  ユーザは、本規約に定めるほか、当社が提供する説明書等の記載内容を遵守して、本サービスを適切に利用するものとします。
5  当社は、当社の裁量により本サービスの仕様を変更できるものとし、本サービスの利用に重大な影響を与える仕様変更に該当すると当社にて判断するものについては、ユーザに通知するものとします。

<span class="sub-header">第8条（委託）</span>
当社は、ユーザに対する本サービスの提供に関して必要となる業務の全部または一部を当社の判断にて第三者に委託することができます。この場合、当社は、当該第三者（以下「当社委託先」といいます。）に対し、本規約に定める当社の義務と同等の義務を負わせるものとします。

<span class="sub-header">第9条（本サービス利用料金）</span>
本サービスの利用料金は、別途当社とユーザとの合意により定める金額とします。

<span class="sub-header">第10条（ユーザID・パスワードの通知）</span>
当社は、別途当社と利用希望者との合意に従い、ユーザID・パスワードを利用希望者に通知するものとします。当社の責めに帰すことのできない事由によりユーザID・パスワードの通知が遅延した場合であっても、当社は一切の責任を負わないものとします。

<span class="sub-header">第11条（本サービスの一時中断および提供停止 ）</span>
1  当社は、次の各号のいずれかに該当する場合には、ユーザへの事前の通知または承諾を要することなく、本サービスの提供を中断することができるものとします。
(1) 本サービス用設備の故障により保守を行う場合
(2) 運用上または技術上の理由でやむを得ない場合
(3) その他天災地変、重大な疾病、騒乱、暴動等不可抗力により本サービスを提供できない場合
2  当社は、本サービス用設備の定期点検を行うため、ユーザに事前に通知の上、本サービスの提供を一時的に中断することができるものとします。
3  当社は、ユーザが第26条（即時解除）第1項各号のいずれかに該当する場合には、ユーザへの事前の通知もしくは催告を要することなく本サービスの全部または一部の提供を停止することができるものとします。
4 前三項に基づき本サービスの提供を中断し、または本サービスの全部または一部の提供を停止する場合であっても、ユーザは、本サービス利用料金の返金を当社に請求できないものとします。
5  当社は、第1項ないし第3項に定める事由のいずれかにより本サービスを提供できなかったことに関してユーザ、顧客または第三者が損害を被った場合であっても、一切の責任を負わないものとします。

<span class="sub-header">第12条（本サービス用設備の障害等）</span>
1  当社は、本サービス用設備について障害があることを知ったときは、遅滞なくユーザにその旨を通知するものとします。
2  当社は、本サービス用設備のうち、本サービス用設備に接続する当社が借り受けた電気通信回線について障害があることを知ったときは、当該電気通信回線を提供する電気通信事業者に修理または復旧を指示するものとします。
3 前二項の場合にユーザが本サービスを利用できなかったとしても、当社は一切の責任を負わないものとします。
4 前各項のほか、本サービスに不具合が発生したときは、ユーザおよび当社はそれぞれ遅滞なく相手方に通知し、両者協議のうえ各自の行うべき対応措置を決定したうえでそれを実施するものとします。

<span class="sub-header">第13条（ユーザからの本サービス利用契約の解約）</span>
1 ユーザは、解約希望日の60日前までに当社が定める方法により当社に通知することで、本サービス利用契約を解約することができるものとします。
2 ユーザが本サービス利用契約を解約した場合であっても、ユーザは、支払い済みの本サービス利用料金の返金を当社に請求できないものとします。

<span class="sub-header">第14条（本サービスの廃止）</span>
1  当社は、次の各号のいずれかに該当する場合、本サービスの全部または一部を廃止することができるものとします。
(1) 廃止日の60 日前までにユーザに通知した場合
(2) 天災地変、重大な疾病、騒乱、暴動等不可抗力により本サービスが提供できない場合
2  前項に基づき本サービスの全部または一部を廃止する場合であっても、ユーザは、本サービス利用料金の返金を当社に請求できないものとします。
3  当社は、前各項に定める事由のいずれかにより本サービスを提供できなかったことに関してユーザ、顧客または第三者が損害を被った場合であっても、一切の責任を負わないものとします。

<span class="sub-header">第15条（禁止事項）</span>
1 ユーザは、本サービスを利用するにあたり、次の各号に規定の行為を行ってはならないものとします。
(1) 当社または第三者の知的財産権を侵害する行為、またはそのおそれのある行為
(2) 本サービスの内容や本サービスにより利用できる情報を改竄または不当に消去する行為
(3) 当社の許諾なく第三者に本サービスを利用させる行為
(4) 法令もしくは公序良俗に違反し、または当社もしくは第三者に不利益を与える行為
(5) 犯罪に結びつきまたは結びつくおそれのある行為
(6) 他のユーザのユーザID・パスワード（他のユーザが第16条第5項に基づき発行したIDおよびパスワードを含みます。）を利用すること等、第三者になりすまして本サービスを利用する行為
(7) ウィルス等有害なコンピュータ・プログラム等を送信または掲載する行為
(8) データセンターや通信回線に過大な負荷を生じさせる行為、その他本サービスの運営に支障を及ぼす行為
(9) リバース・エンジニアリング、データコンパイル、逆アセンブルおよびそれらに類する行為
(10) 第三者の財産、プライバシーもしくは肖像権を侵害し、または侵害するおそれのある行為
(11) 本サービスの利用に際し、当社が指定する方法以外の方法でアクセスする行為
(12) 本サービスのソースコードにアクセスする行為
(13) 本規約その他本サービス利用契約に違反する行為、またはそのおそれのある行為
(14) 前各号に定める行為を助長または促進する行為
(15) 前各号の趣旨に照らし、当社が不適切と判断した行為
2 ユーザは、前項各号のいずれかに該当する行為がなされたことまたはそのおそれがあることを知った場合、直ちに当社に通知するものとします
3 当社は、本サービスの利用に関して、ユーザの行為が第1項各号のいずれかに該当するものであること、またはユーザに関連して入手した情報が第1項各号のいずれかの行為に関連する情報であることを知った場合、事前にユーザに通知することなく、本サービスの全部または一部の提供を一時停止することができるものとします。これによりユーザまたは顧客に何らかの損失または損害が生じたとしても、当社は一切責任を負わないものとします。

<span class="sub-header">第16条（ユーザID・パスワードの管理）</span>
1  ユーザは、ユーザID・パスワードを厳重な注意をもって管理するものとし、当社の許諾なく、第三者に開示してはならないものとします。
2  ユーザID・パスワードを用いて本サービスが利用された場合、当社は、当該利用がそのユーザID・パスワードが割り当てられたユーザによりなされたものとみなします。
3  ユーザID・パスワードの管理不十分（パスワードの適宜変更を行っていないことを含みます。）、使用上の過誤、第三者の使用等により生じた損害について、当社は一切の責任を負わないものとします。
4  ユーザは、ユーザID・パスワードを失念した場合、または第三者に使用されていることを知った場合には、直ちにその旨を当社に連絡するとともに、当社から指示がある場合には、これに従うものとします。
5 ユーザは、別途当社とユーザとの間の合意に基づき、自己の役職員に対し、自ら本サービスを利用可能なIDおよびパスワードを発行することができるものとします。この場合、ユーザが発行したIDおよびパスワードを用いた本サービスの利用は、全てユーザによる本サービスの利用とみなすものとし、かつ、ユーザが発行したIDおよびパスワードについて本条の定めを準用するものとします。

<span class="sub-header">第17条（ユーザ機器等の設置および維持）</span>
1  ユーザは、自らの負担と責任においてユーザ機器等を設置・利用・管理するものとします。
2  本サービスの利用にあたり必要となる通信回線利用料その他これに係る諸経費は、本サービス利用料金には含まれず、ユーザが負担するものとします。

<span class="sub-header">第18条（データの管理）</span>
1. 当社は、本サービス利用契約の期間中であるか否かを問わず、本データを保存する義務を負いません。
2  ユーザは、本データの内容の適切性を自らの責任において判断のうえ、本サービスを利用するものとします。
3  当社は、本データの滅失または損傷について、一切の責任を負わないものとします。
4  当社は、本サービス利用契約の期間中であるか否かを問わず、本サービスの改善や新サービスの開発その他当社の事業のため、本データにアクセスし、解析、加工または利用できるものとします。
5 ユーザは、自らの本データへアクセスし、解析、加工または利用することができるものとします。
6  前二項に定めるほか、当社は、第三者においてユーザおよび顧客が特定できない形式に本データを加工した上で、当社の事業のために利用する場合があります。
7 ユーザは、当社および当社委託先による本データの解析、加工または利用につき対価を請求できないものとします。

<span class="sub-header">第19条（情報や資料等の提供）</span>
1  ユーザは、当社からの要請がある場合、本サービスの履行に必要であると当社が判断する情報または資料等（以下「資料等」といいます。）を無償で当社に提供するものとします。
2  当社は、ユーザの事前の承諾を得ることなく、本サービス遂行上必要な範囲内で資料等を当社委託先に利用させることができるものとします。
3  ユーザが提供した資料等の誤りによって当社または第三者が損害を被った場合、ユーザはその損害（弁護士費用を含みます。）を賠償するものとします。

<span class="sub-header">第20条（非保証）</span>
1  当社が本サービスを通じてユーザに提供する各種数値、データ、予測値等は参考値であり、その正確性を保証するものではありません。ユーザは、本サービスによって得られる各種数値、データ、予測値等を基に、自らの責任において自らの行動を決定するものとします。
2  前項に定めるほか、当社は、本サービスおよび本データに関して、正確性、完全性、有用性、最新性、商業的な利用可能性、特定目的への適合性および特定結果の実現性について、いかなる保証も行わないものとします。

<span class="sub-header">第21条（知的財産権の取扱い）</span>
1  本サービス利用契約の締結は、本サービス利用契約に定める範囲内でユーザに本サービスの利用を許諾するものであり、ユーザに対して本サービスに関する知的財産権を譲渡するものではないものとします。
2  ユーザは、当社または当社へのライセンサーの知的財産権に係る権利表示および説明を変更してはならないものとします。
3  本サービスが第三者の知的財産権（以下「第三者知的財産権」といいます。）を侵害しているとして、ユーザと第三者との間で紛争が生じた場合（そのおそれのある場合を含み、以下、「紛争等」といいます。）には、ユーザは、当社に対して、当該紛争等の発生を速やかに通知するものとします。
4  ユーザが、当社の承諾なく、和解その他の方法により紛争等を解決した場合には、当社は、ユーザに発生した損害または費用（損害賠償金または和解金の支払いを含みます。）について、一切の責任を負わないものとします。
5  第3項の紛争等が生じた場合であっても、次の各号のいずれかに該当するときは、当社は、ユーザが被った損害または費用について一切責任を負わないものとします。
(1) 当該紛争等がユーザその他の第三者の指示に直接起因する場合
(2) 当該紛争等が本サービスの変更に起因し、当該変更が当社によりなされたものでない場合
(3) 当該紛争等が、本製品を他の製品または本サービス以外のサービスと組み合わせたことに起因する場合
(4) 前各号のほか、当該紛争等が当社の責めに帰することのできない事由に起因する場合
6  ユーザは、本サービスに関して、当社または当社のライセンサーの知的財産権を侵害した場合には、当社または当社のライセンサーが被った一切の損害（弁護士費用を含みます。）を賠償するものとします。

<span class="sub-header">第22条（秘密の保持）</span>
1 ユーザおよび当社は、本サービス利用契約の履行に関連して秘密または非公開とすべき範囲を特定したうえで、開示または提供された相手方の技術上、販売上その他業務上の情報（以下「秘密情報」といいます。）を、相手方の書面による事前の承諾を得た場合を除き、第三者に対して開示、漏洩しないものとします。
2 前項にかかわらず、以下の情報は、秘密または非公開である旨の表示を問わず、また、開示の態様を問わず、当社の秘密情報とみなします。
(1) 本サービスの提供に係るデータの測定、解析および処理に関する情報（本データを含みますが、これに限られません。）
(2) 本サービスの性能、耐久性等の開発、分析、評価に関する情報
3 前二項にかかわらず、次の各号のいずれかに該当する情報は秘密情報から除くものとします。
(1) 開示の時点で既に公知のもの、または開示後秘密情報を受領した当事者の責によらずして公知となったもの
(2) 当社またはユーザが開示を行った時点で既に相手方が保有しているもの
(3) 第三者から秘密保持義務を負うことなく正当に入手したもの
(4) 相手方の秘密情報によることなく独自に開発したもの
4  第1項の定めにかかわらず、ユーザおよび当社は、秘密情報のうち法令の定めに基づき裁判所または権限のある行政機関からの要求があった場合、当該要求を満たす必要最小限の範囲で秘密情報を開示することができるものとします。ユーザおよび当社は、関連法令に反しない限り、当該開示前に開示する旨および開示の対象となる秘密情報を相手方に通知するものとし、開示前に通知を行うことができない場合は開示後速やかに相手方に通知するものとします。
5 第1項の定めにかかわらず、ユーザおよび当社は、弁護士、会計士その他の法律上秘密保持義務を負う専門家に対しては、相手方の書面による事前の承諾なく、秘密情報を開示することができるものとします。
6  秘密情報の開示または提供を受けた当事者は、当該秘密情報の管理に必要な措置を講ずるものとします。
7  秘密情報の開示または提供を受けた当事者は、当該秘密情報を本サービス遂行目的その他本サービス利用契約で使用が認められた範囲内でのみ使用し、本サービス遂行上必要な範囲内で秘密情報を複製することができるものとします。この場合、ユーザおよび当社は、当該複製された秘密情報についても、本条に定める秘密情報として取扱うものとします。
8  前各項の規定にかかわらず、本サービス遂行上当社が必要と認めた場合には、必要な範囲で、ユーザから事前の承諾を受けることなくインフラ提供者に対し秘密情報を開示することができるものとします。ただし、当社は本条に基づき当社が負う秘密保持義務と同等の義務をインフラ提供者に負わせるものとします。
9 秘密情報の開示または提供を受けた当事者は、相手方の要請があったときは秘密情報およびその複製物を相手方に返還し、秘密情報がユーザ機器等やデータセンターのサーバ等に記録されている場合はこれを消去するものとします。
10 本条の規定は、本サービス利用契約終了後、2年間（ただし、本項乃至第12項については、本サービス利用契約終了後も期間の定めなく）有効に存続するものとします。ただし、第2項に定める情報については、本サービス利用契約終了後においても、本条の規定が引き続き有効に適用されるものとします。
11 ユーザおよび当社は、相手方から開示された秘密情報の漏洩の事実を覚知した場合は、直ちに相手方へ通知するとともに、対応策について協議するものとします。
12当社またはユーザの責めに帰すべき事由により相手方の秘密情報が漏洩し、これにより当該相手方に損害（弁護士費用を含みます。）が生じた場合、当社またはユーザは当該相手方に対し第24条（損害賠償）に定めるところにより、損害賠償責任を負うものとします。

<span class="sub-header">第23条（ユーザの名称等の使用）</span>
当社は、本製品または本サービスの販売促進資料、説明資料および当社のウェブページ等において、本製品または本サービスの導入例を紹介する目的に限り、ユーザの名称および商標、ロゴ等の標章を使用することができるものとします。

<span class="sub-header">第24条（損害賠償）</span>
当社の故意もしくは重過失による場合、または、第22条（秘密保持）違反の場合を除き、いかなる請求原因であるかにかかわらず、当社はユーザに対して本サービスに起因または関連して損害賠償の義務を負担する場合における当該義務は、合計して、ユーザが当社に現に支払った本サービスの利用料金の累計合計額を超えないものとし、これを超えた部分については損害賠償を行う義務を負わないものとします。また、故意もしくは重過失による場合、または、第24条（秘密保持）違反の場合であっても、当社は、ユーザが現実に被った通常かつ直接の損害に限り責任を負うものとし、特別の事情によって生じた損害および逸失利益等については、その予見の有無を問わず、一切の責任を負わないものとします。

<span class="sub-header">第25条（免責）</span>
1  当社は、次の各号のいずれかの事由に起因又は関連してユーザに発生した損害については、債務不履行責任、不法行為責任、その他の法律上の請求原因の如何を問わず賠償の責任を負わないものとします。
(1) 天災地変、重大な疾病、騒乱、暴動等の不可抗力
(2) ユーザ機器等の障害または本サービス用設備までのインターネット接続サービスの不具合等、契約者の接続環境の障害
(3) インフラ提供者の設備またはサービスに発生した障害
(4) 本サービス用設備からの応答時間等インターネット接続サービスの性能値
(5) 当社が第三者から導入しているコンピュータウィルス対策ソフトについて当該第三者からウィルスパターン、ウィルス定義ファイル等を提供されていない種類のコンピュータウィルスの本サービス用設備への侵入
(6) 善良なる管理者の注意をもってしても防御し得ない本サービス用設備への第三者による不正アクセスまたはアタック、通信経路上での傍受
(7) 当社が説明書等において定める手順・セキュリティ手段等をユーザが遵守しないこと
(8) 本サービス用設備のうち当社の製造に係らないソフトウェア(オペレーションソフトウェア、ミドルウェア、データベース管理システム)およびデータベース
(9) 本サービス用設備のうち、当社の製造に係らないハードウェア
(10) 電気通信事業者の提供する電気通信役務の不具合
(11) 刑事訴訟法第218条（令状による差押え・捜索・検証）、犯罪捜査のための通信傍受に関する法律の定めに基づく強制の処分その他裁判所の命令または法令に基づく強制的な処分
(12) 当社委託先の業務（当社委託先の選任・監督につき当社に帰責事由がある場合を除きます。）
(13) 災害の発生等、当社の責めに帰すべからざる事由により、測定結果が不正確なものとなったこと
(14) その他当社の責めに帰すべからざる事由
2  当社は、ユーザが本サービスを利用することによりユーザと第三者（顧客を含みます。）との間で生じた紛争等について一切責任を負わないものとします。
3  本規約に定める免責規定（本条の規定を含みますが、これに限られません。）が無効であると判断された場合であっても、前条はなお有効に適用されるものとします。

<span class="sub-header">第26条（即時解除）</span>
当社は、ユーザが次の各号のいずれかに該当した場合、ユーザに対する催告および自己の債務の履行の提供を要することなく、直ちに本サービス利用契約の全部または一部を解除することができるものとします。なお、かかる解除は、ユーザに対する損害賠償請求を妨げないものとします。
(1) 本規約に定める各条項を含め、本サービス利用契約に違反し、相当期間を定めた書面による催告後、当該期間が経過してもなお是正されないとき
(2) 本サービスの利用にあたり当社に通知した内容等に虚偽または不備があったとき
(3) 支払の停止または破産手続開始、民事再生手続開始、会社更生手続開始もしくは特別清算開始の申立があったとき
(4) 手形交換所の取引停止処分を受けたとき
(5) 差押、仮差押、仮処分、公売処分、租税滞納処分その他公権力の処分を受けたとき
(6) 資本減少、営業廃止もしくは変更または解散、組織変更の決議をしたとき
(7) 当社に対する債務の一つでも弁済を怠ったとき
(8) 著しい背信行為のあったとき
(9) その他財産状態が悪化し、またはそのおそれがあると認められる相当の事由があるとき
(10)         前各号の他、本サービス利用契約を継続し難い相当の理由があるとき

<span class="sub-header">第27条（契約終了後の処理）</span>
1 ユーザは、本サービス利用契約が終了した場合、本サービスの利用にあたって当社から貸与された資料等（全部または一部の複製物を含みます。以下同じ。）を契約終了後30日以内に当社にユーザの費用負担にて返還し、資料等に関する電子データが提供された場合には、ユーザの責任で消去するものとします。
2 理由を問わず、本サービス利用契約が終了した後であっても、第6条第2項、第7条第3項、第10条第2文、第11条第4項および第5項、第12条第3項、第13条第2項、第14条第2項および第3項、第15条第3項、第16条第3項、第18条、第19条第3項、第20条、第21条第3項乃至第6項、第22条（ただし、同条第10項に定める期間に限る。）、第23条乃至本条、第28条第4項および第5項、ならびに第29条乃至第31条の各規定は引き続き有効に存続するものとします。

<span class="sub-header">第28条（反社会的勢力の排除）</span>
1  ユーザは、本サービス利用契約締結時において、ユーザの代表者、役員、または実質的に経営を支配する者が反社会的勢力に該当しないことを表明し、かつ将来にわたっても該当しないことを確約するものとします。
2  当社が前項の該当性の判断のために調査を要すると判断した場合、ユーザはその調査に協力し、当社が要請する資料を提出するものとします。
3  当社は、ユーザが前二項のいずれかの規定に違反した場合、催告をすることなく、サービス利用契約を解除することができるものとします。
4  ユーザが第1項または第2項に違反したことにより、当社が損害を被った場合には、当社はユーザに対してその損害（弁護士費用を含みます。）の賠償を請求することができるものとします。
5 第3項によりサービス利用契約が解除されたことに関してユーザが損害を被った場合であっても、ユーザは当社に対し、その名目を問わず、解除に関し生じた損害について一切の請求をしないものとします。

<span class="sub-header">第29条（権利義務の譲渡等）</span>
ユーザは、本サービス利用契約に基づく権利義務の一部または全部について、当社の事前の書面による承諾なしに、第三者に譲渡し、または担保の目的に供してはならないものとします。

<span class="sub-header">第30条（本規約の有効性等）</span>
1  本規約のいずれかの部分が無効または適用不可能と判断された場合であっても、本規約の他の部分の有効性や適用可能性は影響されないものとし、無効または適用不可能と判断された部分については、法律により許容される範囲内で当該部分の趣旨に最も近い規定と置き換えられたうえで、本サービス利用契約の内容となるものとします。
2  当社またはユーザが相手方による本規約の規定の遵守を強制せず、または要請しなかったとしても、当該規定を放棄したとはみなされず、当該規定その他の規定を強制する権利になんら影響を与えないものとします。

<span class="sub-header">第31条（準拠法と裁判管轄）</span>
1  本サービス利用契約は、日本法に基づき解釈されるものとします。
2  本サービスに起因または関連して、当社とユーザとの間において争いが生じたときは、東京地方裁判所を第一審の専属的合意管轄裁判所とします。

付則
本規約は、2020年９月９日から適用します。
    </pre>
  </div>
</template>

<script>
export default {
//
}
</script>

<style lang="scss" scoped>
.pre-content{
  white-space: pre-wrap;
  padding: 100px 100px 50px 100px;
  max-width: 900px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba(0,0,0,.1);
  line-height: 1.6;
}
.sub-header{
  font-weight: bold;
}
.view-content{
  flex-direction: column;
  align-items: center;
}
</style>
